import { Container, Stack, Typography } from "@mui/material";

export default function CustomFormError() {
    return (
        <Container maxWidth="md">
            <Stack spacing={2} p={4} alignItems="center">
                <Typography variant="h6" color="error">
                    Form not found or unavailable
                </Typography>
                <Typography variant="body1">
                    The form you are trying to access does not exist or is no longer available.
                </Typography>
            </Stack>
        </Container>
    );
}
